import React from 'react'
import Seo from '../Seo/Seo'
import { LuCheckCircle, LuPhone, LuMail } from 'react-icons/lu'

const offerings = [
  'Parallel 4-Year Extended Certification Program',
  'Short-Term Certification Program',
  'PLEX Score, an employability indicator',
]

const benefits = [
  'An institutionalized PLEX score helps employers differentiate between candidates.',
  'It gives employers an understanding of the strength and characteristics of a student.',
  'It helps students focus on areas of improvement and get job-ready.',
  'It facilitates college placements.',
]

const helps = [
  'Industry-certified programs enhance your capability.',
  'Get knowledge of the latest technologies.',
  'Prepare for the corporate environment.',
  'Earn an increased employability score.',
  'Participate in innovation and research projects.',
  'Experience almost real-life project scenarios.',
  'Receive mentoring from industry professionals.',
]

const CheckList = ({ items }) => (
  <ul className='check_list'>
    {items.map((t) => (
      <li key={t}><LuCheckCircle size={18} />{t}</li>
    ))}
  </ul>
)

const Student = () => {
  return (
    <>
      <Seo
        title='For Students | Industry certifications and PLEX score | CLI'
        description='Learn the technologies industry actually uses. CLI offers industry-certified programs, real-life projects, mentoring and the PLEX employability score.'
        path='/student'
      />
      <header className='page_hero'>
        <span className='home_eyebrow'>For students</span>
        <h1>Learning for a progressive future</h1>
        <p className='home_lead'>A stimulating, application-based learning ecosystem that brings industry knowledge to you.</p>
      </header>

      <div className='page_body'>
        <div className='bento'>
          <div className='bento_card span-4 tone-soft'>
            <h3 className='bento_title'>Do you know what industry actually uses?</h3>
            <p className='bento_para'>Do you want to know about the latest developments in the industry and the technologies used to execute work? Are you familiar with the concepts and working methodologies used by companies? Do you have a sound understanding of the industry domain?</p>
          </div>
          <div className='bento_card tone-brand'>
            <h3 className='bento_title'>This is where we come in</h3>
            <p className='bento_para'>Our programs follow a mixed mode of learning, bringing industry knowledge to you.</p>
          </div>
        </div>

        <section className='page_section'>
          <span className='home_eyebrow'>Offerings</span>
          <h2 className='home_heading'>What MindMatrix Labs offers</h2>
          <ul className='tag_list'>
            {offerings.map((o) => <li key={o}>{o}</li>)}
          </ul>
        </section>

        <section className='page_section'>
          <div className='bento' style={{ marginTop: 0 }}>
            <div className='bento_card span-3 tone-accent'>
              <span className='bento_num'>PLEX</span>
              <h3 className='bento_title'>Participate, Learn, Explore</h3>
              <p className='bento_para'>We have established a unique mechanism to measure a student's competencies using a methodology on our learning platform. The PLEX score is a standardized indicator of employability in a student's area of specialization.</p>
            </div>
            <div className='bento_card span-3'>
              <h3 className='bento_title'>Benefits</h3>
              <CheckList items={benefits} />
            </div>
          </div>
        </section>

        <section className='page_section'>
          <span className='home_eyebrow'>Transformational education</span>
          <h2 className='home_heading'>How MindMatrix Labs helps students</h2>
          <CheckList items={helps} />
        </section>

        <div className='bento'>
          <div className='bento_card span-3'>
            <h3 className='bento_title'>How will you benefit as a student?</h3>
            <p className='bento_para'>As Steve Jobs put it, "Innovation distinguishes between a leader and a follower." Our programs provide the tools to lead and innovate.</p>
          </div>
          <div className='bento_card span-3 tone-brand'>
            <h3 className='bento_title'>Contact us</h3>
            <p className='bento_para'>We help you acquire the right skills to get hired.</p>
            <div className='cta_row'>
              <a className='btn btn_light' href='tel:+919611546444'><LuPhone /> +91 96115 46444</a>
              <a className='btn btn_light' href='mailto:contact@mindmatrix.io'><LuMail /> contact@mindmatrix.io</a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Student
